export const handleRejectedThunk = <GenericState>(callback: (state: GenericState, action: any) => void) => {
    return (state: GenericState, action: any) => {
        if (action?.error?.name === 'AbortError') {
            return;
        }

        callback(state, action);
    };
};
